<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Send Group Emails</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Notification</a>
                            </li>
                            <li class="breadcrumb-item active">Send Group Emails
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Send Group Emails</h4>
                </div>
                <div class="card-body">
                    <form novalidate @submit.prevent="sendEmail">
                        <validation-errors></validation-errors>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label for="site_name" class="form-label">User Group</label>
                                <select v-model="group.group_name" id="" class="form-control" required>
                                    <option value="" selected>Select a user group</option>
                                    <option value="passengers" selected>Passenger</option>
                                    <option value="drivers" selected>Driver</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label for="site_name" class="form-label">Email Subject</label>
                                <input type="text" class="form-control" required v-model="group.subject">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="form-label">Email Content</label>
                                <vue-editor v-model="group.content"></vue-editor>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {VueEditor} from "vue2-editor";
import ValidationErrors from "../../Shared/ValidationErrors";

export default {
    metaInfo: {title: 'Send Group Email'},
    name: 'GroupEmail',
    props: ['settingsData'],
    components: {
        VueEditor,
        ValidationErrors
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            group: [],
        }
    },
    methods: {
        async sendEmail() {
            this.saving = true;
            this.$inertia.post(route('admin.notifications.group.emails.store'), {...this.group}, {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            });
        }
    },
}
</script>
